import type { VoidFunctionComponent } from 'react';

import FallbackImage from '../../../generic/FallbackImage';

import styles from './emptyStates.module.less';

/**
 * Empty state shown when a project's type does not support snippet analysis.
 */
const UnsupportedSnippetProjectType: VoidFunctionComponent = () => {
  return (
    <div className={`panel ${styles.emptyState}`}>
      <FallbackImage
        src="unavailable"
        alt="Snippet analysis unavailable"
        hasPadding
      >
        <header className={styles.emptyStateHeader}>Snippet analysis unavailable</header>
        <p className={styles.emptyStateMessage}>
          Snippet analysis is only available for projects analyzed via the CLI.
          Snippet analysis also requires source code to analyze.
          This is not available with some projects types (such as imported SBOMs).
        </p>
      </FallbackImage>
    </div>
  );
};

export default UnsupportedSnippetProjectType;
